import { createRoute } from '@tanstack/react-router'
import { t } from 'i18next'

import { DynamicRouteParameterWPrefix } from 'config/routing'
import { Config } from 'domains/ContentStores/ExternalStores/ExternalStore'
import { externalStoresRoute } from 'pages/NWPlatform/ContentStores/ExternalStores'
import { Structure } from 'pages/NWPlatform/ContentStores/ExternalStores/ExternalStore'

export const externalStoreRoute = createRoute({
  getParentRoute: () => externalStoresRoute,
  path: DynamicRouteParameterWPrefix.EXTERNAL_STORE_ID,
  loader: () => ({
    crumb: t('entity:content.externalStore', { count: 1 }),
  }),
})

export const externalStoreLayoutRoute = createRoute({
  getParentRoute: () => externalStoreRoute,
  id: 'externalStoreLayout',
  component: () => <Structure />,
})

export const externalStoreConfigRoute = createRoute({
  getParentRoute: () => externalStoreLayoutRoute,
  path: '/',
  component: Config,
})
